import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const upwind = defineConnector({
  identifier: "upwind",
  name: "Upwind",
  tagLine: "Runtime cloud security",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://.*\\.upwind\\.io/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create API credentials in Upwind",
      items: [
        {
          kind: "markdown",
          content: `1. In the Upwind console, go to **Settings › API**
2. Generate a client ID and client secret
3. Copy the client ID and client secret, along with your organization ID`,
        },
      ],
    },
    {
      title: "Enter your Upwind credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
        {
          kind: "input",
          label: "Organization ID",
          required: true,
          target: { kind: "configuration", field: "orgId" },
          helperText: "Your Upwind organization ID.",
        },
        {
          kind: "select",
          label: "Region",
          required: true,
          target: { kind: "configuration", field: "audience" },
          defaultValue: "https://api.upwind.io",
          helperText: "The Upwind region your organization is hosted in.",
          options: [
            { value: "https://api.upwind.io", label: "US" },
            { value: "https://api.eu.upwind.io", label: "EU" },
            { value: "https://api.me.upwind.io", label: "ME" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: () => "https://auth.upwind.io/oauth/token",
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_post",
    scopes: () => [],
    authorizationParameters: ({ audience }): Record<string, string> =>
      audience ? { audience } : {},
  },
  connectionTest: {
    protocol: "http",
    request: ({ audience, orgId }) =>
      `${audience}/v1/organizations/${orgId}/threat-detections?per-page=1`,
  },
});
